import { ref, computed, onUnmounted } from 'vue'

export function useCountdown(seconds = 60) {
  const countdown = ref(0)
  const isCounting = computed(() => countdown.value > 0)
  let timer: ReturnType<typeof setInterval> | null = null

  function start() {
    if (isCounting.value) return
    countdown.value = seconds
    timer = setInterval(() => {
      countdown.value--
      if (countdown.value <= 0 && timer) {
        clearInterval(timer)
        timer = null
      }
    }, 1000)
  }

  onUnmounted(() => {
    if (timer) clearInterval(timer)
  })

  return { countdown, isCounting, start }
}
